import type { CurrencyObject } from '@app/types';

export const SET_USER_CURRENCY = 'iron/currency/SET_USER_CURRENCY';
export const UPDATE_USER_CURRENCY = 'iron/currency/UPDATE_USER_CURRENCY';
export const GET_ALL_CURRENCIES = 'iron/currency/GET_ALL_CURRENCIES';
export const SET_ALL_CURRENCIES = 'iron/currency/SET_ALL_CURRENCIES';

export const setUserCurrency = ({
  customerId = null,
  currency,
  locale,
  reload = false,
}) => ({
  type: SET_USER_CURRENCY,
  payload: {
    customerId,
    currency,
    locale,
    reload,
  },
});

export const updateUserCurrency = ({
  currency,
  locale,
}: {
  currency: string;
  locale: string;
}) => ({
  type: UPDATE_USER_CURRENCY,
  payload: { currency, locale },
});

export const getAllCurrencies = () => ({
  type: GET_ALL_CURRENCIES,
});

export const setAllCurrencies = (currencies: Dict<CurrencyObject>) => ({
  type: SET_ALL_CURRENCIES,
  payload: { currencies },
});
